import I18n from 'I18n';
import ActionButtonComponent from '../ActionButtonComponent';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { jsx as _jsx } from "react/jsx-runtime";
const ForwardButton = ({
  collapsed,
  genericChannelId,
  onClick
}) => {
  const onButtonClick = e => {
    onClick(e);
    usageTracker.track('message-forward', {
      action: 'message forward',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    onClick: onButtonClick,
    collapsed: collapsed,
    buttonIcon: 'forward',
    "data-test-id": 'forward-button',
    i18nButtonText: I18n.text('conversations-inbox-message-history.email.forward')
  });
};
ForwardButton.displayName = 'ForwardButton';
export default ForwardButton;